import React, { Component } from 'react';
import {
  Button,
  Row,
  Col,
  Input,
  InputGroup,
  InputGroupText,
  Alert,
} from 'reactstrap';

import ReactTooltip from 'react-tooltip';

import { WorkOrderForm } from './WorkOrderForm';
import { LoadingModal } from './LoadingModal';
import { PrintInvoiceGridDefault } from './PrintInvoiceGridDefault';
import { FetchData, FetchFile } from './utils/DataFetch';
import { GetCookie, Timeout, openFileInNewTab, downloadFile } from './utils/Common';


import PrintIcon from '../images/print-icon.png';

const moment = require('moment');

export class PrintInvoice extends Component {
  static displayName = PrintInvoice.name;

  constructor(props) {
    super(props);
    this.state = {
      workOrderList: [],
      jobHistoryList: [],
      jobInvLineList: [],

      executiveUsers: [],

      receivableList: [],
      receivableItemList: [],

      viewInvoiceNum: '',
      loading: true,
      modal: false,
      fetchingData: false,
      modalClient: false,
      modalIntFormEmail: false,
      modalRepFormEmail: false,
      modalWOJobNotes: false,
      modalViewInvoice: false,
      showInvoiced: false,
      selectedIndex: -1,
      checkAll: false,
      alert: {
        color: 'info',
        message: '',
        isOpen: false,
      },
      model: {
        EventType: 'insert',
        JobNum: 0,
        JobId: null,
        JobDateTime: null,
        JobTime: null,
        FinishTime: null,
        FinishTimeString: null,
        FollowupDate: null,
        ProvId: null,
        ProviderName: '',
        ConfCallNote: '',
        AptName: '',
        AptStreet: '',
        AptCity: '',
        AptState: '',
        AptZip: '',
        AptPhone: '',
        AptDirection: '',
        FailedFlg: false,
        CallerNote: '',
        InvoiceNote: '',
        IntCheckDate: null,
        IntCheckNum: null,
        InvoicedFlg: false,
        JobTotal: null,
        JobDiscount: null,
        IntFee: null,
        IntFeeOther: null,
        IntOTFee: null,
        IntFeeNote: '',
        TransportationFlg: false,
        TransConfFlg: false,
        IntConfFlg: false,
        AppointmentTypeId: '9e5e4810-c5a8-428b-8f7d-71422b6b77e3', // conf call
        CallerType: null,
        ProvConfFlg: false,
        ClmConfFlg: false,
        IsDeletedFlg: false,
        BillReviewedFlg: false,
        AuditFlg: false,
        PurpleReportFlg: false,
        RepAuthorizedFlg: false,
        SelectedFlg: false,
        ClmId: '',
        ClmFirstName: '',
        ClmLastName: '',
        ClmClaimNumber: '',
        ClmClaimNumberNoDash: '',
        ClmPhone: '',
        ClmDateOfLoss: '',
        ClmDateOfInjury: '',
        ClmDateOfInjuryStart: null,
        ClmDateOfInjuryEnd: null,
        ClmNote: '',
        ClmDOB: null,
        ClmInsuredParty: '',
        ClmEmployer: '',
        ClmInvoiceCaption: '',
        ClmLanguage: '',
        ClmWCABNumber: '',
        ClmInvoiceType: '',
        ClmStreet: '',
        ClmCity: '',
        ClmState: '',
        ClmZip: '',
        ClmSSN: '',
        ClmOrderedByName: '',
        ClmDiagnosis: '',
        ClmEmail: '',
        RepID: null,
        RepFirstName: '',
        RepLastName: '',
        RepPhone: '',
        RepEmail: '',
        ClientId: '',
        ClientAbbrv: '',
        ClientName: '',
        ClientStreet: '',
        ClientStreet2: '',
        ClientCity: '',
        ClientState: '',
        ClientZip: '',
        ClientMailStreet: '',
        ClientMailStreet2: '',
        ClientMailCity: '',
        ClientMailState: '',
        ClientMailZip: '',
        ClientPhone: '',
        ClientPhoneFax: '',
        ClientPhone2: '',
        ClientEmail: '',
        ClientInactiveFlg: false,
        IntId: null,
        IntLastName: '',
        IntFirstName: '',
        IntCellTxt: '',
        IntPhoneOnly: '',
        IntEmail: '',
        IntNote: '',
        InHouseFlg: false,
        IntCity: '',
        IntStreet: '',
        IntState: '',
        IntZip: '',
        DBA: '',
        Rate: 0,
        HourMinimum: 0,
        Prorate: '',
        BankRoute: '',
        BankAccount: '',
        IntSSINumber: '',
        FirstName: '',
        LastName: '',
        UserType: '',
        UserIntId: null,
        CreateDateTime: null,
        CreateByUserId: null,
        RemIntFlg: false,
        RemClaimFlg: false,
        RemProvFlg: false,
        RemFinalFlg: false,
        RemType: null,
        RemTypeDesc: '',
        RemHost: null,
        RemHostDesc: '',
        CreatedBy: '',
        UpdatedBy: '',
        MyJobTJobHistory: '',
        JobBalance: null,
      },
      client: {
        EventType: 'update',
        ClientId: null,
        ClientAbbrv: '',
        ClientPhone: '',
        ClientPhone2: '',
        ClientPhoneFax: '',
        ClientName: '',
        ClientMailStreet: '',
        ClientMailStreet2: '',
        ClientMailCity: '',
        ClientMailState: '',
        ClientMailZip: '',
        ClientStreet: '',
        ClientStreet2: '',
        ClientCity: '',
        ClientState: '',
        ClientZip: '',
        ClientCountry: '',
        ClientDiscount: null,
        ClientNotes: '',
        ClientCreditCard: '',
        ClientEmailForInvoice: '',
        ClientEmail: '',
        ClientWebsite: '',
        ClientOrg: '',
        ClientBillRateType: '',
        ClientInactiveFlg: false,
        CreateDateTime: null,
        CreateByUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
      },
      searchModel: {
        IntId: '',
        ClmId: '',
        JobNum: null,
        StartDate: null,
        EndDate: null,
        Claimant: '',
        ClmClaimNumberNoDash: '',
        CLMPhone: '',
        Interpreter: '',
        Rep: '',
        ClientAbbrv: '',
        ProviderName: '',
        ShowPrinted: false,
        CreatedByUserId: null,
        MyJobs: false,
        MyJobsUser: '',
        InvoicedFlg: false,
      },
      email: {
        EmailFrom: '',
        EmailTo: '',
        EmailCC: '',
        Subject: '',
        Body: '',
        JobIds: '',
      },
      dayNames: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ],
      monthNames: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],

      tableView: 'default',
    };
    //
    this.user = JSON.parse(GetCookie('user'));
    // button clicks
    //this.resetFields = this.resetFields.bind(this);
    this.setData = this.setData.bind(this);
    this.setModal = this.setModal.bind(this);
    this.viewInvoice = this.viewInvoice.bind(this);
    //
    this.renderPrintInvoiceTable = this.renderPrintInvoiceTable.bind(this);
    //
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearchFocus = this.handleSearchFocus.bind(this);
    this.handleSearchBlur = this.handleSearchBlur.bind(this);
    //
    this.handleKeyDown = this.handleKeyDown.bind(this);
    // export reports
    //this.printInvoice = this.printInvoice.bind(this);
    this.exportPDF = this.exportPDF.bind(this);
    this.exportSinglePDF = this.exportSinglePDF.bind(this);
    this.exportCombinedPDF = this.exportCombinedPDF.bind(this);
    this.exportSinglePDF = this.exportSinglePDF.bind(this);
    this.exportCombinedPDF = this.exportCombinedPDF.bind(this);
    this.updateInvoicedFlgAndInsertReceivable =
      this.updateInvoicedFlgAndInsertReceivable.bind(this);
    this.resetInvoiced = this.resetInvoiced.bind(this);
    //
    this.handleCheckAll = this.handleCheckAll.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.resetChecks = this.resetChecks.bind(this);
    //
    //    this.handleSortData = this.handleSortData.bind(this);
    //    this.requestSort = this.requestSort.bind(this);
    //    //
    //    this.onClickResizeColumn = this.onClickResizeColumn.bind(this);
    //    this.handleOnMouseUp = this.handleOnMouseUp.bind(this);
  }

  componentDidMount() {
    this.populatePrintInvoice();
  }

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  setModal() {
    this.setState(
      {
        modal: !this.state.modal,
      },
      () => {
        if (!this.state.modal) {
          this.setState({
            selectedIndex: -1,
          });
        }
      },
    );
  }

  viewInvoice(woData, i) {
    let body = {
      JobIdsList: '',
    };

    body.JobIdsList = woData.jobId;
    let invoiceFileName = 'Invoice ' + woData.jobNum + '.pdf';

    FetchFile(
      '/printinvoices?combineIntoSinglePdf=true',
      'POST',
      this.user.token,
      body,
    ).then((blob) => {
      if (!blob || blob.size === 0) {
        this.handleSaveEventSuccess({ color: 'warning', message: 'No file returned.', modal: false });
        return;
      }
      downloadFile(blob, invoiceFileName);
    });
  }

  setData(woData, rowIndex, showModal) {
    FetchData(
      '/getworkorder?jobId=' + woData.jobId,
      'POST',
      this.user.token,
      null,
    ).then((data) => {
      this.setState(
        (prevState) => ({
          model: {
            EventType: 'update',
            JobNum: data.jobNum,
            JobId: data.jobId,
            JobDateTime: data.jobDateTime,
            JobTime: data.jobTime,
            FinishTime: data.finishTime,
            FinishTimeString:
              data.finishTimeString === '00:00' ? null : data.finishTimeString,
            FollowupDate: data.followupDate,
            ProvId: data.provId,
            ProviderName: data.providerName,
            ConfCallNote: data.confCallNote,
            AptName: data.aptName,
            AptStreet: data.aptStreet,
            AptCity: data.aptCity,
            AptState: data.aptState,
            AptZip: data.aptZip,
            AptPhone: data.aptPhone,
            AptDirection: data.aptDirection,
            FailedFlg: data.failedFlg,
            CallerNote: data.callerNote,
            InvoiceNote: data.invoiceNote,
            IntCheckDate: data.intCheckDate,
            IntCheckNum: data.intCheckNum,
            InvoicedFlg: data.invoicedFlg,
            JobTotal: data.jobTotal,
            JobDiscount: data.jobDiscount,
            IntFee: data.intFee === null ? null : parseInt(data.intFee),
            IntFeeOther:
              data.intFeeOther === null ? null : parseInt(data.intFeeOther),
            IntOTFee: data.intOTFee === null ? null : parseInt(data.intOTFee),
            IntFeeNote: data.intFeeNote,
            TransportationFlg: data.transportationFlg,
            TransConfFlg: data.transConfFlg,
            IntConfFlg: data.intConfFlg,
            AppointmentTypeId: data.appointmentTypeId,
            CallerType: data.callerType,
            ProvConfFlg: data.provConfFlg,
            ClmConfFlg: data.clmConfFlg,
            IsDeletedFlg: data.isDeletedFlg,
            BillReviewedFlg: data.billReviewedFlg,
            AuditFlg: data.auditFlg,
            PurpleReportFlg: data.purpleReportFlg,
            RepAuthorizedFlg: data.repAuthorizedFlg,
            SelectedFlg: data.selectedFlg,
            ClmId: data.clmId,
            ClmFirstName: data.clmFirstName,
            ClmLastName: data.clmLastName,
            ClmClaimNumber: data.clmClaimNumber,
            ClmClaimNumberNoDash: data.clmClaimNumberNoDash,
            ClmPhone: data.clmPhone,
            ClmDateOfLoss: data.clmDateOfLoss,
            ClmDateOfInjury: data.clmDateOfInjury,
            ClmDateOfInjuryStart: data.clmDateOfInjuryStart,
            ClmDateOfInjuryEnd: data.clmDateOfInjuryEnd,
            ClmNote: data.clmNote,
            ClmDOB: data.clmDOB,
            ClmInsuredParty: data.clmInsuredParty,
            ClmEmployer: data.clmEmployer,
            ClmInvoiceCaption: data.clmInvoiceCaption,
            ClmLanguage: data.clmLanguage,
            ClmWCABNumber: data.clmWCABNumber,
            ClmInvoiceType: data.clmInvoiceType,
            ClmStreet: data.clmStreet,
            ClmCity: data.clmCity,
            ClmState: data.clmState,
            ClmZip: data.clmZip,
            ClmSSN: data.clmSSN,
            ClmOrderedByName: data.clmOrderedByName,
            ClmDiagnosis: data.clmDiagnosis,
            ClmEmail: data.clmEmail,
            RepID: data.repID,
            RepFirstName: data.repFirstName,
            RepLastName: data.repLastName,
            RepPhone: data.repPhone,
            RepEmail: data.repEmail,
            ClientId: data.clientId,
            ClientAbbrv: data.clientAbbrv,
            ClientName: data.clientName,
            ClientStreet: data.clientStreet,
            ClientStreet2: data.clientStreet2,
            ClientCity: data.clientCity,
            ClientState: data.clientState,
            ClientZip: data.clientZip,
            ClientMailStreet: data.clientMailStreet,
            ClientMailStreet2: data.clientMailStreet2,
            ClientMailCity: data.clientMailCity,
            ClientMailState: data.clientMailState,
            ClientMailZip: data.clientMailZip,
            ClientPhone: data.clientPhone,
            ClientPhoneFax: data.clientPhoneFax,
            ClientPhone2: data.clientPhone2,
            ClientEmail: data.clientEmail,
            ClientInactiveFlg: data.clientInactiveFlg,
            IntId: data.intId,
            IntLastName: data.intLastName,
            IntFirstName: data.intFirstName,
            IntCellTxt: data.intCellTxt,
            IntPhoneOnly: data.intPhoneOnly,
            IntEmail: data.intEmail,
            IntNote: data.intNote,
            InHouseFlg: data.inHouseFlg,
            IntCity: data.intCity,
            IntStreet: data.intStreet,
            IntState: data.intState,
            IntZip: data.intZip,
            DBA: data.dDBA,
            Rate: data.rate,
            HourMinimum: data.hourMinimum,
            Prorate: data.prorate,
            BankRoute: data.bankRoute,
            BankAccount: data.bankAccount,
            IntSSINumber: data.intSSINumber,
            FirstName: data.firstName,
            LastName: data.lastName,
            UserType: data.userType,
            UserIntId: data.userIntId,
            CreateDateTime: data.createDateTime,
            CreateByUserId: data.createByUserId,
            UpdateDateTime: data.updateDateTime,
            UpdateByUserId: data.updateByUserId,
            RemIntFlg: data.remIntFlg,
            RemClaimFlg: data.remClaimFlg,
            RemProvFlg: data.remProvFlg,
            RemFinalFlg: data.remFinalFlg,
            RemType: data.remType,
            RemTypeDesc: data.remTypeDesc,
            RemHost: data.remHost,
            RemHostDesc: data.remHostDesc,
            CreatedBy: data.createdBy,
            UpdatedBy: data.updatedBy,
            MyJobTJobHistory: data.myJobTJobHistory,
            MyJobWaitingOnCallBack: data.myJobWaitingOnCallBack,
            JobBalance: data.jobBalance,
            WorkFlowId: data.workFlowId,
          },
        }),
        () => {
          this.setModal();
        },
      );
    });
  }

  async openWorkOrderForm(jobId) {
    FetchData(
      '/getworkorder?jobId=' + jobId,
      'POST',
      this.user.token,
      null,
    ).then((data) => {
      this.setState((prevState) => ({
        model: {
          EventType: 'update',
          JobNum: data.jobNum,
          JobId: data.jobId,
          JobDateTime: data.jobDateTime,
          JobTime: data.jobTime,
          FinishTime: data.finishTime,
          FinishTimeString:
            data.finishTimeString === '00:00' ? null : data.finishTimeString,
          FollowupDate: data.followupDate,
          ProvId: data.provId,
          ProviderName: data.providerName,
          ConfCallNote: data.confCallNote,
          AptName: data.aptName,
          AptStreet: data.aptStreet,
          AptCity: data.aptCity,
          AptState: data.aptState,
          AptZip: data.aptZip,
          AptPhone: data.aptPhone,
          AptDirection: data.aptDirection,
          FailedFlg: data.failedFlg,
          CallerNote: data.callerNote,
          InvoiceNote: data.invoiceNote,
          IntCheckDate: data.intCheckDate,
          IntCheckNum: data.intCheckNum,
          InvoicedFlg: data.invoicedFlg,
          JobTotal: data.jobTotal,
          JobDiscount: data.jobDiscount,
          IntFee: data.intFee === null ? null : parseInt(data.intFee),
          IntFeeOther:
            data.intFeeOther === null ? null : parseInt(data.intFeeOther),
          IntOTFee: data.intOTFee === null ? null : parseInt(data.intOTFee),
          IntFeeNote: data.intFeeNote,
          TransportationFlg: data.transportationFlg,
          TransConfFlg: data.transConfFlg,
          IntConfFlg: data.intConfFlg,
          AppointmentTypeId: data.appointmentTypeId,
          CallerType: data.callerType,
          ProvConfFlg: data.provConfFlg,
          ClmConfFlg: data.clmConfFlg,
          IsDeletedFlg: data.isDeletedFlg,
          BillReviewedFlg: data.billReviewedFlg,
          AuditFlg: data.auditFlg,
          PurpleReportFlg: data.purpleReportFlg,
          RepAuthorizedFlg: data.repAuthorizedFlg,
          SelectedFlg: data.selectedFlg,
          ClmId: data.clmId,
          ClmFirstName: data.clmFirstName,
          ClmLastName: data.clmLastName,
          ClmClaimNumber: data.clmClaimNumber,
          ClmClaimNumberNoDash: data.clmClaimNumberNoDash,
          ClmPhone: data.clmPhone,
          ClmDateOfLoss: data.clmDateOfLoss,
          ClmDateOfInjury: data.clmDateOfInjury,
          ClmDateOfInjuryStart: data.clmDateOfInjuryStart,
          ClmDateOfInjuryEnd: data.clmDateOfInjuryEnd,
          ClmNote: data.clmNote,
          ClmDOB: data.clmDOB,
          ClmInsuredParty: data.clmInsuredParty,
          ClmEmployer: data.clmEmployer,
          ClmInvoiceCaption: data.clmInvoiceCaption,
          ClmLanguage: data.clmLanguage,
          ClmWCABNumber: data.clmWCABNumber,
          ClmInvoiceType: data.clmInvoiceType,
          ClmStreet: data.clmStreet,
          ClmCity: data.clmCity,
          ClmState: data.clmState,
          ClmZip: data.clmZip,
          ClmSSN: data.clmSSN,
          ClmOrderedByName: data.clmOrderedByName,
          ClmDiagnosis: data.clmDiagnosis,
          ClmEmail: data.clmEmail,
          RepID: data.repID,
          RepFirstName: data.repFirstName,
          RepLastName: data.repLastName,
          RepPhone: data.repPhone,
          RepEmail: data.repEmail,
          ClientId: data.clientId,
          ClientAbbrv: data.clientAbbrv,
          ClientName: data.clientName,
          ClientStreet: data.clientStreet,
          ClientStreet2: data.clientStreet2,
          ClientCity: data.clientCity,
          ClientState: data.clientState,
          ClientZip: data.clientZip,
          ClientMailStreet: data.clientMailStreet,
          ClientMailStreet2: data.clientMailStreet2,
          ClientMailCity: data.clientMailCity,
          ClientMailState: data.clientMailState,
          ClientMailZip: data.clientMailZip,
          ClientPhone: data.clientPhone,
          ClientPhoneFax: data.clientPhoneFax,
          ClientPhone2: data.clientPhone2,
          ClientEmail: data.clientEmail,
          ClientInactiveFlg: data.clientInactiveFlg,
          IntId: data.intId,
          IntLastName: data.intLastName,
          IntFirstName: data.intFirstName,
          IntCellTxt: data.IntCellTxt,
          IntPhoneOnly: data.IntPhoneOnly,
          IntEmail: data.intEmail,
          IntNote: data.intNote,
          InHouseFlg: data.inHouseFlg,
          IntCity: data.intCity,
          IntStreet: data.intStreet,
          IntState: data.intState,
          IntZip: data.intZip,
          DBA: data.dDBA,
          Rate: data.rate,
          HourMinimum: data.hourMinimum,
          Prorate: data.prorate,
          BankRoute: data.bankRoute,
          BankAccount: data.bankAccount,
          IntSSINumber: data.intSSINumber,
          FirstName: data.firstName,
          LastName: data.lastName,
          UserType: data.userType,
          UserIntId: data.userIntId,
          CreateDateTime: data.createDateTime,
          CreateByUserId: data.createByUserId,
          UpdateDateTime: data.updateDateTime,
          UpdateByUserId: data.updateByUserId,
          RemIntFlg: data.remIntFlg,
          RemClaimFlg: data.remClaimFlg,
          RemProvFlg: data.remProvFlg,
          RemFinalFlg: data.remFinalFlg,
          RemType: data.remType,
          RemTypeDesc: data.remTypeDesc,
          RemHost: data.remHost,
          RemHostDesc: data.remHostDesc,
          CreatedBy: data.createdBy,
          UpdatedBy: data.updatedBy,
          MyJobTJobHistory: data.myJobTJobHistory,
          JobBalance: data.jobBalance,
        },
        selectedIndex: 0,
        modal: true,
      }));
    });
  }

  getJobHistory(jobId) {
    let model = {
      JobId: jobId,
    };

    FetchData('/getjobhistory', 'POST', this.user.token, model).then((data) => {
      this.setState({
        jobHistoryList: Array.isArray(data) ? data : [],
        fetchingData: false,
      });
    });
  }

  getJoInvLine(jobId) {
    let model = {
      JobId: jobId,
    };
    FetchData('/getjobinvline', 'POST', this.user.token, model).then((data) => {
      this.setState({ jobInvLineList: data, fetchingData: false });
    });
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        modal: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, 3000);
        if (alert.modal === false)
          if (this.state.tableView === 'default') this.populatePrintInvoice();
          else this.populateWorkOrderPendingData();
      },
    );
  }

  handleSearchChange(e) {
    let model = { ...this.state.searchModel };
    if (e.target.type === 'checkbox') {
      model[e.target.name] = e.target.checked;
    } else if (e.target.type === 'number') {
      model[e.target.name] = e.target.value === '' ? null : e.target.value;
    } else {
      model[e.target.name] = e.target.value;
    }
    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      if (this.state.tableView === 'default') {
        this.populatePrintInvoice();
      } else this.populateWorkOrderPendingData();
    }
  }

  handleSearchFocus(e) {
    if (e.target.value !== '') {
      let model = { ...this.state.searchModel };

      if (e.target.name === 'StartDate' || e.target.name === 'EndDate') {
        model[e.target.name] = moment(e.target.value).format('MM/DD/YYYY');
      } else model[e.target.name] = e.target.value;

      this.setState({ searchModel: model });
    }

    if (e.target.name === 'StartDate' && e.target.type !== 'date') {
      e.target.type = 'date';
    }
    if (e.target.name === 'EndDate' && e.target.type !== 'date') {
      e.target.type = 'date';
    }
  }

  handleSearchBlur(e) {
    e.target.type =
      (e.target.name === 'StartDate' || e.target.name === 'EndDate') &&
      e.target.value !== ''
        ? 'date'
        : 'text';
  }

  handleCheckAll = () => {
    this.setState(
      {
        checkAll: !this.state.checkAll,
      },
      () => {
        this.state.workOrderList.forEach((item) =>
          this.setState({ ['chk_' + item.jobNum]: this.state.checkAll }),
        );
      },
    );
  };

  handleCheckChange = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.checked,
      },
      () => {
        const uncheckedItems = (this.state.workOrderList ?? []).filter(
          (item) => !this.state['chk_' + item.jobNum],
        );
        this.setState({
          checkAll: uncheckedItems.length === 0,
        });
      },
    );
  };

  resetChecks = () => {
    this.setState(
      {
        checkAll: false,
      },
      () => {
        (this.state.workOrderList ?? []).forEach((item) =>
          this.setState({ ['chk_' + item.jobNum]: false }),
        );
      },
    );
  };

  async exportPDF() {
    let JobsList = [];
    let body = {
      JobIdsList: '',
    };
    let invoiceFileNameBase = 'Invoices';

    this.state.workOrderList.forEach((item) => {
      if (this.state['chk_' + item.jobNum]) {
        JobsList.push(item.jobId);
      }
    });
    body.JobIdsList = JobsList.join();

    if (body.JobIdsList === '') {
      this.setState(
        {
          alert: {
            color: 'warning',
            message: 'Please check any work order',
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout('Please check any work order'));
        },
      );
    } else {
      await FetchFile(
        '/printinvoices?combineIntoSinglePdf=true',
        'POST',
        this.user.token,
        body,
      ).then((blob) => {
        if (!blob || blob.size === 0) {
          this.handleSaveEventSuccess({ color: 'warning', message: 'No file returned.', modal: false });
          return;
        }
        downloadFile(blob, invoiceFileNameBase + '.pdf');
        this.updateInvoicedFlgAndInsertReceivable();
      });

      this.resetChecks();
      this.populatePrintInvoice();
    }
  }

  async exportSinglePDF() {
    const selectedWorkOrders = this.state.workOrderList.filter(
      (item) => this.state['chk_' + item.jobNum],
    );

    if (selectedWorkOrders.length === 0) {
      this.setState(
        {
          alert: {
            color: 'warning',
            message: 'Please check any work order',
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout('Please check any work order'));
        },
      );
      return;
    }

    for (const workOrder of selectedWorkOrders) {
      const body = {
        JobIdsList: workOrder.jobId,
      };

      await FetchFile(
        '/printinvoices?combineIntoSinglePdf=true',
        'POST',
        this.user.token,
        body,
      ).then((blob) => {
        if (!blob || blob.size === 0) {
          this.handleSaveEventSuccess({ color: 'warning', message: 'No file returned.', modal: false });
          return;
        }
        downloadFile(blob, 'Invoice ' + workOrder.jobNum + '.pdf');
      });
    }

    this.updateInvoicedFlgAndInsertReceivable();
    this.resetChecks();
    this.populatePrintInvoice();
  }

  async exportCombinedPDF() {
    await this.exportPDF();
  }

  updateInvoicedFlgAndInsertReceivable() {
    let userModel = { ...this.user };
    let jobsList = [];

    this.state.workOrderList.forEach((item) => {
      if (this.state['chk_' + item.jobNum]) {
        jobsList.push(item.jobId);
      }
    });

    jobsList.forEach((invoiceId) => {
      var data = {
        JobId: invoiceId,
        UpdateByUserId: userModel.userid,
      };

      FetchData(
        '/updateinvoiceFlgandinsertreceivable',
        'POST',
        this.user.token,
        data,
      ).then((data) => {
        this.handleSaveEventSuccess({
          message: data,
          model: data === 'Success' ? true : false,
          color: data === 'Success' ? 'success' : 'warning',
        });
      });
    });

    //this.handleSearchFocus();
    this.populatePrintInvoice();
  }

  resetInvoiced() {
    let userModel = { ...this.user };
    let jobsList = [];

    this.state.workOrderList.forEach((item) => {
      if (this.state['chk_' + item.jobNum]) {
        jobsList.push(item.jobId);
      }
    });

    if (jobsList.length === 0) {
      this.setState(
        {
          alert: {
            color: 'warning',
            message: 'Please check any work order',
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout('Please check any work order'));
        },
      );
    } else {
      jobsList.forEach((invoiceId) => {
        var data = {
          JobId: invoiceId,
          UpdateByUserId: userModel.userid,
          Note: '',
        };

        FetchData('/resetinvoicedFlg', 'POST', this.user.token, data).then(
          (data) => {
            this.handleSaveEventSuccess({
              message: data,
              model: data === 'Success' ? false : true,
              color: data === 'Success' ? 'success' : 'warning',
            });
          },
        );
      });
      //this.handleSearchFocus();
      this.resetChecks();
      this.setState(
        (prev) => ({ searchModel: { ...prev.searchModel, ShowPrinted: false } }),
        () => this.populatePrintInvoice(),
      );
    }
  }

  async populatePrintInvoice() {
    this.setState({ fetchingData: true });

    let model = { ...this.state.searchModel };
    model.StartDate =
      model.StartDate === '' || model.StartDate === null
        ? null
        : moment(model.StartDate).format('YYYY-MM-DD');
    model.EndDate =
      model.EndDate === '' || model.EndDate === null
        ? null
        : moment(model.EndDate).format('YYYY-MM-DD');

    // Detect a pasted list of invoice numbers in the Invoice # field.
    // Split on commas, whitespace, or semicolons so pasting from Excel works too.
    const jobNums = (model.JobNum ?? '')
      .toString()
      .split(/[\s,;]+/)
      .map((n) => n.trim())
      .filter((n) => n !== '');

    if (jobNums.length > 1) {
      // Multi-invoice mode: one lookup per number, ignore the other text filters,
      // and match regardless of printed/invoiced status.
      this.setState({ searchModel: model });

      const baseFilters = {
        ...model,
        JobIdsList: '',
        Rep: '',
        Claimant: '',
        ClmClaimNumberNoDash: '',
        ClientAbbrv: '',
        StartDate: null,
        EndDate: null,
        ShowPrinted: null,
      };

      const results = await Promise.all(
        jobNums.map((num) =>
          FetchData('/getinvoices', 'POST', this.user.token, {
            ...baseFilters,
            JobNum: num,
          }).then((data) => (Array.isArray(data) ? data : [])),
        ),
      );

      // Merge + de-dupe by jobId.
      const merged = [];
      const seen = new Set();
      results.flat().forEach((wo) => {
        if (wo && !seen.has(wo.jobId)) {
          seen.add(wo.jobId);
          merged.push(wo);
        }
      });

      // Auto-check every matched row.
      const checks = {};
      merged.forEach((item) => {
        checks['chk_' + item.jobNum] = true;
      });

      const foundNums = new Set(merged.map((m) => (m.jobNum ?? '').toString()));
      const missing = jobNums.filter((n) => !foundNums.has(n));

      this.setState({
        workOrderList: merged,
        loading: false,
        fetchingData: false,
        checkAll: merged.length > 0,
        ...checks,
      });

      this.setState(
        {
          alert: {
            color: missing.length === 0 ? 'success' : 'warning',
            message:
              missing.length === 0
                ? `Found and selected all ${merged.length} invoice(s).`
                : `Found ${merged.length} of ${jobNums.length}. Not found: ${missing.join(', ')}`,
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, 5000);
        },
      );

      return;
    }

    // Single / normal search — unchanged behavior.
    model.JobNum = jobNums.length === 1 ? jobNums[0] : null;
    let url = '/getinvoices';

    this.setState({ searchModel: model }, () => {
      FetchData(url, 'POST', this.user.token, model).then((data) => {
        this.setState({
          workOrderList: Array.isArray(data) ? data : [],
          loading: false,
          fetchingData: false,
        });
      });
    });

    this.resetChecks();
  }

  renderPrintInvoiceTable(workOrders) {
    return (
      <PrintInvoiceGridDefault
        state={this.state}
        handleCheckChange={this.handleCheckChange}
        handleCheckAll={this.handleCheckAll}
        workOrders={this.state.workOrderList}
        viewInvoice={this.viewInvoice}
        setData={this.setData}
      ></PrintInvoiceGridDefault>
    );
  }

  render() {
    let contents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : this.state.tableView === 'default' ? (
      this.renderPrintInvoiceTable(this.state.workOrderList)
    ) : (
      this.renderPrintInvoiceTable(this.state.workOrderList)
    );

    return (
      <div style={{ paddingTop: '12px' }}>
        <center>
          <Alert
            color={this.state.alert.color}
            isOpen={this.state.alert.isOpen}
          >
            {this.state.alert.message}
          </Alert>
        </center>
        <Row>
          <Col className="col-9">
            <InputGroup size="small">
              <InputGroupText
                className="input-group-text"
                style={{ width: '80px', color: 'black' }}
              >
                {' '}
                Show Printed{' '}
              </InputGroupText>
              <Input
                name="ShowPrinted"
                type="checkbox"
                className="input-checkbox form-check-input"
                checked={this.state.searchModel.ShowPrinted}
                onChange={this.handleSearchChange}
              />
              <span style={{ paddingRight: '4px' }}></span>
              <input
                name="JobNum"
                id="jobnum"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.JobNum ?? ''}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                placeholder="Invoice #  (one or comma-separated)"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="Rep"
                id="rep"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Rep}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                placeholder="Rep"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="Claimant"
                id="claimant"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Claimant}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                placeholder="Claimant"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="ClmClaimNumberNoDash"
                id="claimnum"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.ClmClaimNumberNoDash}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                placeholder="Claimant #"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="ClientAbbrv"
                id="clientabbrv"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.ClientAbbrv}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                placeholder="Client Abbrv"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="StartDate"
                id="startdate"
                type="date"
                max={'9999-12-31'}
                className="form-control form-control-text"
                value={this.state.searchModel.StartDate ?? ''}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                onBlur={this.handleSearchBlur}
                placeholder="Start Date"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="EndDate"
                id="enddate"
                type="date"
                max={'9999-12-31'}
                className="form-control form-control-text"
                value={this.state.searchModel.EndDate ?? ''}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                onBlur={this.handleSearchBlur}
                placeholder="End Date"
                onKeyDown={this.handleKeyDown}
              />
              <Button
                color="btn"
                id="printinv"
                onClick={this.exportSinglePDF}
                size="sm"
              >
                <img src={PrintIcon} alt="Print Single Invoices" />
                Print Single Invoices
              </Button>
              <Button
                color="btn"
                id="printinvcombined"
                onClick={this.exportCombinedPDF}
                size="sm"
              >
                <img src={PrintIcon} alt="Print Combined Invoices" />
                Print Combined Invoices
              </Button>
              <Button
                color="btn"
                id="resetinvoiced"
                onClick={this.resetInvoiced}
                size="sm"
              >
                <img src={PrintIcon} alt="Reset Invoiced" />
                Reset Invoiced
              </Button>
            </InputGroup>
          </Col>
        </Row>

        <LoadingModal fetchingData={this.state.fetchingData} />

        <ReactTooltip
          id="rtp"
          place="right"
          type="dark"
          effect="solid"
          html={true}
        />
        <div>{contents}</div>

        {this.state.modal && (
          <WorkOrderForm
            model={this.state.model}
            modal={this.state.modal}
            alert={this.state.alert}
            setModal={this.setModal}
            workOrderList={this.state.workOrderList}
            jobHistoryList={this.state.jobHistoryList}
            jobInvLineList={this.state.jobInvLineList}
            setNextPrevData={this.setNextPrevData}
            selectedIndex={this.state.selectedIndex}
            handleSaveEventSuccess={this.handleSaveEventSuccess}
          />
        )}
      </div>
    );
  }
}
